/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';

import * as actionTypes from './ActionTypes';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const axiosPayLoad = {
  firstErrorBool: false,
};

// reducer handling function
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_TAB_DATA_DL:
      return {
        ...state,
        searchTabData: action.searchTabData,
      };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_DL:
      return {
        ...state,
        errorMessagesInRedux: action.errorMessagesInRedux,
      };
    case actionTypes.GET_MANUFACTURER_DATA_DL:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
      };
    case actionTypes.MFG_SELECTED_DL:
      return {
        ...state,
        mfgSelected: action.mfgSelected,
      };
    case actionTypes.TEMPLATE_TYPE_LIST_DL:
      return {
        ...state,
        templateTypeList: action.templateTypeList,
      };
    case actionTypes.HANDLE_FIRST_ERROR:
      return {
        ...state,
        firstErrorBool: action.firstErrorBool,
      };
    case actionTypes.TEMPLATE_NAME_LIST_DL:
      return {
        ...state,
        templateNameList: action.templateNameList,
      };
    case actionTypes.TEMP_LETTER_TABLE_DATA:
      return {
        ...state,
        tempLetterTableData: action.tempLetterTableData,
      };
    case actionTypes.GET_PLAN_TYPE_DATA_DL:
      var updatedArray = [];
      if (action.checkbox) {
        var localAr = action.checkbox;
        if (localAr?.PLAN_TYPE_CD?.length > 0) {
          var planArray = localAr?.PLAN_TYPE_CD;
          planArray.forEach((element) => {
            if (element?.codeValueID?.codeValue == 'FD') {
              const indexOf = _.findIndex(planArray, element);

              if (!_.isNull(indexOf) && indexOf >= 0) {
                updatedArray = arrayMove(localAr?.PLAN_TYPE_CD, indexOf, 0);
              }
              localAr.PLAN_TYPE_CD = updatedArray;
            }
          });
        }
      }
      return {
        ...state,
        checkbox: localAr,
      };
    case actionTypes.SAVE_CREATE_LETTER_DATA_DISPLAY:
      return {
        ...state,
        saveCreateLetterData: action.saveCreateLetterData,
      };
    case actionTypes.FETCH_CREATE_LETTER_DETAIL_DATA_DISPLAY:
      return { ...state, createLetterDetail: action.createLetterDetail };
    case actionTypes.FETCH_CREATE_LETTER_DETAIL_DISPLAY:
      return { ...state, detailScrenData: action.detailScrenData };
    case actionTypes.GET_INVOICE_DETAILS_BY_INVOICE_NUM_DISPLAY:
      return { ...state, invoiceDetail: action.invoiceDetail };
    case actionTypes.GET_DISPLAY_TEMPLATE_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.GET_TO_MAIL_ID_DISPLAY:
      return { ...state, toMailId: action.toMailId };
    case actionTypes.GET_FROM_MAIL_ID_DISPLAY:
      return { ...state, fromMailId: action.payload };
    case actionTypes.GET_PRINT_PREVIEW_DISPLAY:
      return { ...state, pdfPreview: action.pdfPreview };
    case actionTypes.GET_PREVIEW_DRAFT_PDF_DISPLAY:
      return { ...state, pdfDraftPreview: action.pdfDraftPreview };
    case actionTypes.SEND_LETTER_BY_EMAIL_DISPLAY:
      return { ...state, sendMail: action.sendMail };
    case actionTypes.RESET_REDUX_DL:
      return [];
    case actionTypes.DISPLAY_LETTER_CLEAR_REDUX_DATA:
      return action.payload ? action.payload : { ...axiosPayLoad };
    default:
      return state;
  }
};

export default reducer;
